module.exports = __webpack_public_path__ + "static/media/moto.0ca811c7.svg";